import { signal } from '@angular/core';
import { ServiceGridItemObject } from '@it2go/types';

export const userServices = signal<ServiceGridItemObject[]>([]);
export const allServices = signal<ServiceGridItemObject[]>([]);
export const servicesDownloaded = signal<boolean>(false);
